import customFetch from '../../utils/customFetch'
import { API_ENDPOINT } from '../../config'
import { suggestionsToApp } from './converters/gacEntity'
import { GeoAutocompletionResult, GeoAutocompletionType } from '../../@types/types'

export const loadGeoAutocompletion: (
  input: string,
  type: GeoAutocompletionType,
  secondInput?: string
) => GeoAutocompletionResult = async (input: string, type: GeoAutocompletionType, secondInput?: string) => {
  const parameters = new URLSearchParams()
  parameters.append('i', input.trim())
  parameters.append('t', type)
  secondInput && secondInput.trim() && parameters.append('x', secondInput.trim())

  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  }
  const url = `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/geo/locations?${parameters.toString()}`
  const response = await customFetch(url, options)
  return suggestionsToApp(await response.json())
}
